import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./theme/ThemeContext";
import { App } from "./App";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root missing in index.html");

createRoot(rootEl).render(
  <StrictMode>
    {/* basename /ui: die SPA lebt unter /ui (same-origin-Serve durch den Master), damit
        die UI-Client-Routen (/agents, /users, …) nie mit den gleichnamigen API-Routen
        kollidieren. Muss zum vite `base: "/ui/"` passen. */}
    <BrowserRouter basename="/ui">
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
